import React from 'react';
import styled from 'styled-components';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { resolvePath } from '@/utils/resolvePath';

const OfferCards = ({
    heading,
    offerCards,
}: {
    heading: string;
    offerCards: any;
}) => {
    const router = useRouter();
    return (
        <OfferCardsWrapper>
            <OfferCardsHeading>{heading}</OfferCardsHeading>
            <OfferCardsBannerWrapper>
                {offerCards?.map((offerCard: any) => {
                    return (
                        <ImageWrapper>
                            {offerCard.redirectionUrl ? (
                                <ImageLinkWrapper
                                    onClick={() => {
                                        router.push(offerCard.redirectionUrl);
                                    }}
                                    href={offerCard.redirectionUrl}
                                >
                                    <Image
                                        src={resolvePath(
                                            offerCard?.imageUrl?.data
                                                ?.attributes?.url
                                        )}
                                        layout="fill"
                                        alt="Navigation"
                                    />
                                </ImageLinkWrapper>
                            ) : (
                                <Image
                                    src={resolvePath(
                                        offerCard?.imageUrl?.data?.attributes
                                            ?.url
                                    )}
                                    layout="fill"
                                    alt="Navigation"
                                />
                            )}
                        </ImageWrapper>
                    );
                })}
            </OfferCardsBannerWrapper>
        </OfferCardsWrapper>
    );
};

export default OfferCards;

const OfferCardsWrapper = styled.div`
    display: flex;
    padding: 20px 16px;
    flex-direction: column;
    align-items: center;
    gap: 20px;
`;

const OfferCardsHeading = styled.h2`
    color: #121212;
    font-family: 'Euclid Circular B';
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: -0.1px;
    align-self: stretch;
    margin: 0;
`;
const OfferCardsBannerWrapper = styled.div`
    display: -webkit-inline-box;
    gap: 12px;
    align-self: stretch;
    overflow-x: scroll;
`;

const ImageWrapper = styled.div`
    position: relative;
    width: calc(100% - 32px);
    height: 120px;
`;

const ImageLinkWrapper = styled.a``;
